export class LogisticClass {
    id!: string;
    label?: string;
    description?: string

    public static of(data: any): LogisticClass {
        const l: LogisticClass = new LogisticClass();

        l.id = data.id;
        l.label = data.label;
        l.description = data.description;

        return l;
    }
}

export class LogisticPrice {
    id?: string;
    amount?: number;
    label?: string;

    public static of(data: any): LogisticPrice {
        const l: LogisticPrice = new LogisticPrice();

        l.id = data.id;
        l.amount = data.amount;
        l.label = data.label;

        return l;
    }
}